import {useState} from "react"; 
import {useEffect} from "react"; 
const CryptoTicker = () => {
  const [prices, setPrices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,ripple,cardano,solana,binancecoin,dogecoin,polkadot,litecoin,chainlink,uniswap,stellar,avalanche-2,tron,shiba-inu,wrapped-bitcoin,terra-luna,vechain,cosmos,monero,theta-token,tezos,aave,algorand,elrond-erd-2,axie-infinity,phantom,near,hedera-hashgraph,decentraland,quant-network,filecoin,flow,ftx-token,gala,the-sandbox,harmony,thorchain,iota,zilliqa,safemoon,celsius,yearn-finance,enjincoin,chiliz,dash,kucoin-shares&vs_currencies=usd"
        );

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        const formattedPrices = Object.keys(data).map((key) => ({
          name: key.charAt(0).toUpperCase() + key.slice(1).replace(/-/g, " "),
          price: data[key].usd,
        }));

        setPrices(formattedPrices);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="text-center text-xl text-white py-10">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-red-500 py-10">Error fetching crypto prices: {error}</div>;
  }

  return (
    <div className=" mx-auto p-6 rounded-lg shadow-lg overflow-hidden">
      <h1 className="text-3xl font-bold text-center text-yellow-400 mb-6">Crypto Prices</h1>
      <div className="marquee bg-gray-900 text-white py-4">
        <div className="flex space-x-8">
          {prices.map((crypto) => (
            <div className="flex items-center space-x-2 p-2 hover:bg-gray-700 transition duration-300 rounded-lg" key={crypto.name}>
              <p className="text-lg font-semibold text-teal-400">{crypto.name}</p>
              <p className={`text-xl font-bold ${crypto.price >= 1000 ? 'text-yellow-400' : 'text-green-400'} transition duration-200`}>
                ${crypto.price}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default CryptoTicker; 

